import ProfileIcon from './component.jsx'
export default ProfileIcon
